export default {
  apiUrl: 'http://yoursite.com/api/',
};
import config from '../config';
import { CONFIG } from '../globalConfig';

const siteConfig = {
  siteName: config.appName,
  siteIcon: 'ion-flash',
  footerText: config.appName + ' ©2025 version ' + config.version,
};
const themeConfig = {
  topbar: 'themedefault',
  sidebar: 'themedefault',
  layout: 'themedefault',
  theme: 'themedefault',
};
const language = CONFIG.LANGUAGE;

const jwtConfig = {
  fetchUrl: '/api/',
  secretKey: 'secretKey',
};

export { jwtConfig, language, siteConfig, themeConfig };

